module.exports = __webpack_public_path__ + "static/media/azr.16e1a532.jpg";